import { ProgressSpinner } from "primereact/progressspinner";

interface LoaderProps {
  style?: any;
}

const Loader = ({ style = {} }: LoaderProps) => (
  <div
    className="flex justify-content-center align-items-center w-full h-full"
    style={style}
  >
    <ProgressSpinner />
  </div>
);

export default Loader;
